import React, { useEffect, useMemo, useState } from 'react'
import { Link } from 'gatsby'
import { ArrowSquareOut, Copy } from '@phosphor-icons/react'
import { useTable } from 'react-table'
import DropdownButton from '@components/common/DropdownButton'
import { getMetricValues } from "@utils"
import {
  menApparelOptions,
  metricOptions,
  countrySizeOptions,
  getCountrySize,
  getMensApparelData,
} from "@components/helpers/SizeAndMetrics"

// assets
import bust from "@images/Products/measure-breast.webp"
import waist from "@images/Products/measure-waist.webp"
import hips from "@images/Products/measure-hips.webp"

const MensApparel = ({data, dropDownContainerStyle = 'flex justify-between items-center'}) => {
  const [apparelSelected, setApparelSelected] = useState(menApparelOptions[0])
  const [countrySize, setCountrySize] = useState([])
  const [metricUsed, setMetricUsed] = useState('IN')
  
  useEffect(() => {
    setCountrySize(getCountrySize('US'))
  }, [])

  const sizeColumns = useMemo(() => [
    {
      Header: '',
      accessor: 'label',
      Cell: ( {value} ) => <span className='font-semibold'>{value}</span>,
    },
    {
      Header: 'S',
      accessor: 's',
      Cell: ( {value} ) => <span>{getMetricValues(value, metricUsed)}</span>,
    },
    {
      Header: 'M',
      accessor: 'm',
      Cell: ( {value} ) => <span>{getMetricValues(value, metricUsed)}</span>,
    },
    {
      Header: 'L',
      accessor: 'l',
      Cell: ( {value} ) => <span>{getMetricValues(value, metricUsed)}</span>,
    },
    {
      Header: 'XL',
      accessor: 'xl',
      Cell: ( {value} ) => <span>{getMetricValues(value, metricUsed)}</span>,
    },
  ], [metricUsed])

  const sizeData = useMemo(() => [
    { ...countrySize },
    ...getMensApparelData(apparelSelected.id)
  ], [countrySize, apparelSelected])
  
  const handleCountrySizeChange = (size) => {
    setCountrySize(getCountrySize(size.label))
  }

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({ columns: sizeColumns, data: sizeData })

  return (
    <React.Fragment>
      <div className={`${dropDownContainerStyle} gap-4`}>
        <div className="flex gap-x-2 flex-1 md:flex-auto justify-between md:justify-start">
          <DropdownButton
            className='dropdown-btn-style w-auto md:w-[240px]'
            optionListWidth={'w-full'}
            defaultOption={menApparelOptions[0]}
            options={menApparelOptions}
            onClick={(apparel) => setApparelSelected(apparel)}
          />
          <DropdownButton
            defaultOption={countrySizeOptions[0]}
            options={countrySizeOptions}
            onClick={(size) => handleCountrySizeChange(size)}
          />
        </div>
        <div className="flex flex-nowrap gap-x-3 overflow-visible">
          <DropdownButton
            label={
              <div className="hidden md:block space-x-2 text-secondary">
                <span>METRICS</span>
                <span>:</span>
              </div>
            }
            defaultOption={metricOptions[0]}
            options={metricOptions}
            onClick={(metric) => setMetricUsed(metric.id)}
          />
        </div>
      </div>

      <div className="">
        <div className="w-full p-2 bg-[#454545] text-white text-center">
          MEN’S SWIM SHORTS
        </div>
        <div className="overflow-x-auto">
          <table {...getTableProps()} className="min-w-full">
            <thead>
              {headerGroups?.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup?.headers?.map((column) => (
                    <th
                      {...column.getHeaderProps()}
                      className="px-6 py-3 text-center border border-slate-200"
                    >
                      {column.render("Header")}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>

            <tbody {...getTableBodyProps()}>
              {rows.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()} key={row.id}>
                    {row.cells.map((cell) => (
                      <td
                        {...cell.getCellProps()}
                        key={cell.column.id}
                        className="px-2 py-3 text-sm border border-slate-200 text-gray-700 text-center"
                      >
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <p className="inline-block w-full text-md pt-16">
          For sizing questions, Email us at{" "}
          <a href="mailto:aloha@blackboughswim.com" target="_blank" className="link-style mx-1">
            <span className="flex gap-x-2 items-center">
              aloha@blackboughswim.com <Copy size={20} />
            </span>
          </a>
          or contact us via our{" "}
          <Link to="/contact-us" className="link-style mx-1">
            <span className="flex gap-x-2 items-center">Contact Form.</span>
          </Link>{" "}
          We’re always eager to help!
        </p>
      </div>
    </React.Fragment>
  );
}

export default MensApparel